import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import Pipeline, { PipelineDefinition } from 'types/pipeline';
import APIError from 'types/api_error';

import { useAPI } from 'hooks/api/useAPI';

import { initializeAPIPipeline } from './usePipelines';

type UseCreatePipelineParams = {
  name?: string;
  definition: PipelineDefinition;
};

export function useCreatePipeline({
  onSettled,
  ...options
}: UseMutationOptions<Pipeline, APIError, UseCreatePipelineParams> = {}) {
  const queryClient = useQueryClient();
  const { applicationID, client } = useAPI();

  return useMutation(
    async (params) => {
      const { data: pipeline } = await client.post<Pipeline>(
        `/apps/${applicationID}/pipelines`,
        params
      );

      return initializeAPIPipeline(
        new Pipeline(
          pipeline.id,
          pipeline.name,
          pipeline.application_id,
          pipeline.definition,
          pipeline.created_at,
          pipeline.updated_at
        )
      );
    },
    {
      ...options,
      onSettled(...args) {
        onSettled?.(...args);
        queryClient.invalidateQueries(['pipelines']);
      },
    }
  );
}
